import React, { FC } from 'react'

import { ReceiptItem } from '../ReceiptItem/ReceiptItem'

import { getRiderHorses } from '../../../../helpers/riders'

import { IHorseData } from '../../../../models/horse/horse.interface'
import {
  HORSE_NAME_DEFAULT,
  IRegistrationByDayInterface,
} from '../../../../models/registrations-by-day/registrationByDay.interface'
import { ITotalPrices } from '../../../../helpers/payment'

interface ReceiptListProps {
  allHorses?: IHorseData[] | null
  classes?: { items: IRegistrationByDayInterface[]; totalPrice: ITotalPrices }
  currency: string
}
export const ReceiptClassesList: FC<ReceiptListProps> = ({ allHorses, classes, currency }) => {
  return (
    <div className="py-5">
      <h3 className="text-base font-semibold mb-3 break-inside-avoid">Classes</h3>
      <div className="space-y-2">
        {classes?.items?.map((item) => {
          const horseNames =
            getRiderHorses(allHorses ?? [], item.horsesSelected || [])
              ?.map((horse) => horse.horseName)
              .join(', ') || HORSE_NAME_DEFAULT

          return (
            <ReceiptItem
              key={item.id}
              title={item.registrationByDayName || 'N/A'}
              description={`${horseNames} • ${item.riderName}`}
              price={item.registrationPrice || 0}
              originalPrice={item.originalRegistrationPrice || 0}
              paidDate={item.paidDate || null}
              cardNo={item.cardNo}
              paymentType={item.paymentType}
              paymentStatus={item.paymentStatus}
              amountRefunded={item.amountRefunded}
              isRefunded={item.refundAmountAdded || false}
              refundedDate={item.refundedDate || null}
              isScratched={item.isScratched}
              scratchedDate={item.scratchedDate || null}
              isQualify={item.isQualify}
              qualifyFeeName={item.qualifyFeeName}
              qualifyFee={item.qualifyFee}
              ownerId={item.riderId}
              ownerName={item.riderName || null}
              recipientId={item.recipientId}
              recipientName={item.recipientName}
              currency={currency}
            />
          )
        })}
      </div>
    </div>
  )
}
